import { render, staticRenderFns } from "./EnrollmentImport.vue?vue&type=template&id=b6ef8bb6&scoped=true"
import script from "./EnrollmentImport.vue?vue&type=script&lang=js"
export * from "./EnrollmentImport.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentImport.vue?vue&type=style&index=0&id=b6ef8bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ef8bb6",
  null
  
)

export default component.exports